import React from "react";
import { useSelector, useDispatch } from "react-redux";
import CustomTabset from "../Components/CustomTabset/CustomTabset.jsx";
import {globals} from "../Components/Globals/Globals.js";
import {loadToolboxPartners} from "../redux/toolboxPartnerSlice.js";
import { Button } from "reactstrap";

// reactstrap components
import {Container, Row} from "reactstrap";

// core components
import ToolboxPartnersRawTableDataSync from "../Components/ToolboxPartnersRawTableDataSync/ToolboxPartnersRawTableDataSync";

const AdminToolboxView = (props) => {
  const dispatch = useDispatch();

  // Get the stats from the store
  const {toolboxPartnersItems, loadToolboxPartners_result} = useSelector((state) => state.toolbox)
  
  React.useEffect(() => {
    // eslint-disable-next-line no-unused-vars
    let isMounted = true

    // If status is !loading, then fetch stats data from the API
    if (loadToolboxPartners_result.status === 'idle'){
      if (globals.parameters.redux_debugging) alert("loading toolboxPartners")
      dispatch(loadToolboxPartners());
    }

    if (loadToolboxPartners_result.status === 'loading'){
      if (globals.parameters.redux_debugging) alert("loading toolboxPartners...")
    }

    // If status is !loading, then fetch stats data from the API
    if (loadToolboxPartners_result.status === 'succeeded'){
      if (globals.parameters.redux_debugging) alert("toolboxPartners successfully loaded")
        console.log("AdminToolboxPartnersView -> toolboxPartnersItems ", toolboxPartnersItems)
    }

    // Cleanup function
    return () => {
      isMounted = false
    }
  }, [loadToolboxPartners_result, dispatch]);


  return (    
        <div className="wrapper">
          <div className="main">
            <div className="section">
              <Container>
                {/** Search toolbar */}
                <CustomTabset activeTabset={"toolbox"}/>
                <Row>
                  <div>
                      {toolboxPartnersItems  &&
                      <ToolboxPartnersRawTableDataSync
                        toolboxPartners_list = {toolboxPartnersItems}
                        />}                 
                </div>
                </Row> 
              </Container>
            </div>
          </div>
        </div>
  );
}

export default AdminToolboxView;
